// Exports
export default {
	"endCallButton": "endCallButton_Wtsag",
	"withAccent": "withAccent_B9D9Z",
	"endCallButtonWrapper": "endCallButtonWrapper_flP9r",
	"button": "button_CKdtv",
	"popup": "popup_jgP0W"
};
